var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerCs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.009 15.833a1.25 1.25 0 0 0 1.228-1.48L18.049 2.686a1.25 1.25 0 0 0-1.232-1.02H1.846A1.25 1.25 0 0 0 .618 3.149l2.187 11.666a1.25 1.25 0 0 0 1.229 1.02h1.882a.417.417 0 0 0 .404-.318l.878-3.583a.625.625 0 0 1 1.214.297l-1.554 6.417a.417.417 0 0 0 .405.516h7.083a.625.625 0 0 0 0-1.25h-2.083a.417.417 0 0 1-.417-.417V16.25c0-.23.187-.417.417-.417h6.746zm-.713-3.453a.625.625 0 1 1-1.226.244l-.166-.833a.625.625 0 0 1 1.225-.244l.167.833zm-2.083 0a.625.625 0 1 1-1.226.244l-.167-.833a.625.625 0 0 1 1.226-.244l.167.833z",
    fill: "#AEB3B7",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerCs);
export default __webpack_public_path__ + "static/media/computer-cs.2316b64e8c56daf218b1143e8821a2cb.svg";
export { ForwardRef as ReactComponent };